import React from 'react';
import SendIcon from '@mui/icons-material/Send';
import * as htmlToImage from 'html-to-image';
import {Button} from '@mui/material';
import {saveAs} from 'file-saver';
import {ExportButton} from './ExportButton';

export const WeatherBroadcastOptions = ({filepath, data, handleOpen}) => {
  return (
    <div className='options-box' style={{display: 'grid', gap: '10px'}}>
      <ExportButton
        filename={filepath}
        data={data}
        exportAsPicture={exportAsPicture}
      />

      {data.broadcaster === 'RBB' && (
        <Button
          size='large'
          style={{textTransform: 'none', margin: '20'}}
          variant='contained'
          color='error'
          endIcon={<SendIcon />}
          // endIcon={<PhotoCamera/>}
          // onClick={() => exportAsPicture(data.broadcaster, map)}
          onClick={handleOpen}>
          Upload
        </Button>
      )}
    </div>
  );
};

const exportAsPicture = (broadcaster, map) => {
  // var data = document.getElementsByClassName('mapview');
  let data = document.getElementsByClassName('mappolino');

  const fileName = map.displayTitle + '.jpg';

  for (let i = 0; i < data.length; ++i) {
    htmlToImage.toPng(data[i]).then(dataUrl => {
      // htmlToImage.toJpeg(data[i]).then((dataUrl) => {
      saveAs(dataUrl, fileName);
    });
  }
};
